import * as ActionTypes from './actionTypes'

export const chainSave = () => ({ type: ActionTypes.surveyChainSave })

export const chainItemDelete = () => ({ type: ActionTypes.surveyChainItemDelete })
